import React from "react";
import styles from "./Toggle.module.css";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, label }) => (
  <div className={styles.wrapper}>
    <div
      className={`${styles.track} ${checked ? styles.trackOn : ""}`}
      onClick={() => onChange(!checked)}
    >
      <div className={`${styles.thumb} ${checked ? styles.thumbOn : ""}`} />
    </div>
    {label && <span className={styles.label}>{label}</span>}
  </div>
);

export default Toggle;
